var $f4d3d6f7a011f704$exports = {};
const $f4d3d6f7a011f704$var$apiKey = "wH1aTA62Rv1D74uPnKlk5kP1VUKEYN03";
const $f4d3d6f7a011f704$var$url = `https://api.nytimes.com/svc/books/v3/lists/overview.json?api-key=${$f4d3d6f7a011f704$var$apiKey}`;
const $f4d3d6f7a011f704$var$gallery = document.getElementById("books-gallery");
const $f4d3d6f7a011f704$var$footer = document.querySelector("footer");
async function $f4d3d6f7a011f704$var$fetchBooks() {
    try {
        const response = await fetch($f4d3d6f7a011f704$var$url);
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const data = await response.json();
        if (data.copyright) {
            const copyrightElem = document.createElement("p");
            copyrightElem.className = "text-sm text-gray-400 mt-2";
            copyrightElem.textContent = data.copyright;
            $f4d3d6f7a011f704$var$footer.appendChild(copyrightElem);
        }
        // Flatten all books from each list
        const books = data.results.lists.flatMap((list)=>list.books);
        books.forEach((book)=>{
            if (!book.title || !book.book_image) return;
            const card = document.createElement("div");
            card.className = "article-card bg-gray-800 border-2 border-cyan-400 rounded overflow-hidden shadow-lg hover:scale-105 transition-transform";
            card.innerHTML = `
        <img src="${book.book_image}" alt="${book.title}" class="w-full h-64 object-cover">
        <div class="p-4">
          <h2 class="text-lg font-bold text-cyan-400 mb-2">${book.title}</h2>
          <p class="text-sm mb-2">${book.description}</p>
          ${book.amazon_product_url ? `<a href="${book.amazon_product_url}" target="_blank" class="text-yellow-400 hover:underline">Buy Now</a>` : ""}
        </div>
      `;
            $f4d3d6f7a011f704$var$gallery.appendChild(card);
        });
    } catch (error) {
        console.error("Error fetching books:", error);
        $f4d3d6f7a011f704$var$gallery.innerHTML = `<p class="text-red-500">Failed to load books. Please try again later.</p>`;
    }
}
$f4d3d6f7a011f704$var$fetchBooks();


//# sourceMappingURL=Books.04607fdf.js.map
